<template>
  <div class="main">
    <div class='container'>
      <b-row class=''>
        <b-col cols=12 lg=6 class='mb-3 pt-2'>
          <!--Fondos-->
          <h4 class="txt-color-secondary py-4" style='height: 80px;'>Funding</h4>
          <b-row class='mt-2'>
            <b-col cols=12>
              <b-card no-body class='p-2'>
                <b-list-group flush>
                  <b-list-group-item
                    button
                    style='background: none;'
                    class='p-0 mb-2'
                    v-for="(item, index) in getBalances" v-bind:key="index"
                  >
                    <b-col cols=12 class=''>
                      <AssetsItem :asset='item'/>
                    </b-col>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
            <b-col cols=12 sm=6>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols=12 lg=6 class='mb-3 pt-2'>
          <!-- SGBT Status -->
          <h4 class="txt-color-secondary py-4">
            SGBT Status
            <span>
              <b-button @click="Withdraw('')" style='' class='btn-sm ml-3' variant="primary">Withdraw</b-button>
            </span>
          </h4>
          <b-row>
            <b-col cols=12 sm=12 md=6 class='mb-2'
              v-for="(item, index) in getDistribution" v-bind:key="index"
            >
              <SimpleItem :item='item'/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class=''>
        <b-col cols=12 lg=6 class='mb-3 pt-2'>
          <!-- Form buy SGBT-->
          <h4 class="txt-color-secondary py-4"> Buy SGBT</h4>
          <div class='card box py-4 mt-2'>
            <b-container>
              <b-form @submit.stop.prevent="onSubmit" >
                <div class='group buy'>
                  <h6 class='txt-color-primary'>From</h6>
                  <b-row>
                    <b-col cols=8 lg=9 class='pr-0'>
                      <!-- TRX -->
                      <b-form-group v-if="selected === 'SGBT/TRX'">
                        <b-input-group class='mb-2'>
                          <b-form-input
                            v-model="updateFormTRX"
                            :formatter="formatter_6"
                            :state="validateState($v.form.TRX)"
                            :disabled='formOnlyUSDT'
                          />
                          <template #append>
                          </template>
                        </b-input-group>
                        <b-form-invalid-feedback class="pl-2" :state="validateState($v.form.TRX)">
                          {{getErrorMessage($v.form.TRX)}}
                        </b-form-invalid-feedback>
                      </b-form-group>
                      <!-- USD -->
                      <b-form-group id='group_usd' v-if="selected === 'SGBT/USDT'">
                        <b-input-group class='mb-2'>
                          <b-form-input
                              v-model="updateFormUSD"
                              :formatter="formatter_6"
                              :state="validateState($v.form.USD)"
                              :disabled='formOnlyUSDT'
                          />
                            <template #append>
                            </template>
                        </b-input-group>
                        <b-form-invalid-feedback class="pl-2" :state="validateState($v.form.USD)">
                          {{getErrorMessage($v.form.USD)}}
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                    <b-col cols=4 lg=3 class='text-right pl-0'>
                      <b-dropdown
                        :text="getBase()"
                        variant="primary"
                        :disabled="formOnlyUSDT"
                      >
                        <b-dropdown-item
                          @click="pair(option.value)"
                          v-for="(option, index) in pairs" v-bind:key="index"
                          v-show='option.show'
                        >
                          {{option.text}}
                        </b-dropdown-item>
                      </b-dropdown>
                    </b-col>
                  </b-row>
                </div>
                <!-- PRICE -->
                <b-col cols=12 class='txt-color-secondary text-right'>
                  <p style='padding: 0.9rem 0rem 0rem 0rem;'> 1 SGBT per {{price(selected)}} {{getBase()}}</p>
                </b-col>
                <div class='group buy'>
                  <h6 class='txt-color-primary'>To</h6>
                  <!-- SGBT $v.form.SGB.$model-->
                  <b-form-group
                    id='group_sgb'
                  >
                    <b-input-group class='mb-2'>
                      <b-form-input
                        v-model="updateFormSGB"
                        :formatter="formatter_9"
                        :state="validateState($v.form.SGB)"
                        :disabled='this.formOnlyUSDT'
                      />
                      <template #append>
                        <b-input-group-text>
                          <h6 class='mb-0' style='width: 35px;'>SGBT</h6>
                        </b-input-group-text>
                      </template>
                    </b-input-group>
                    <b-form-invalid-feedback class="pl-2" :state="validateState($v.form.SGB)">
                        {{getErrorMessage($v.form.SGB)}}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
                <div class='group buy mt-4 txt-color-secondary'>
                  <b-row>
                    <b-col cols=4 class="pr-0"><h6>Cost</h6></b-col>
                    <b-col cols=8 class="text-right pl-0" v-if="selected === 'SGBT/USDT'"><h6>{{this.form.USD}} USDT</h6></b-col>
                    <b-col cols=8 class="text-right pl-0" v-else><h6>{{this.form.TRX}} TRX</h6></b-col>
                  </b-row>
                  <b-row>
                    <b-col cols=4 class="pr-0"><h6>Price</h6></b-col>
                    <b-col cols=8 class="text-right pl-0"><h6>1 SGBT per {{price(selected)}} {{getBase()}}</h6></b-col>
                  </b-row>
                  <b-row>
                    <b-col cols=4 class="pr-0"><h6>Amount</h6></b-col>
                    <b-col cols=8 class="text-right pl-0"><h6>{{this.form.SGB}}</h6></b-col>
                  </b-row>
                  <b-row>
                    <b-col cols=4 class="pr-0"><h6>Fee</h6></b-col>
                    <b-col cols=8 class="text-right pl-0"><h6>-- trx</h6></b-col>
                  </b-row>
                </div>
                <b-row>
                  <b-col cols=12 class='text-center mt-4'>
                    <b-button style='width: 240px;' type="submit" variant="primary">{{getTitleBTN()}}</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-container>
          </div>
        </b-col>
        <b-col cols=12 lg=6 class='mb-3 pt-2'>
          <!-- list all buy SGBT-->
          <h4 class="txt-color-secondary py-4">Buy SGBT-USD</h4>
          <b-row class='mt-2'>
            <ListSimpleBuy :items='getAllBuy' base='USD'/>
          </b-row>
        </b-col>
      </b-row>
      <!-- list mis buy SGBT-->
      <h4 class='txt-color-secondary py-4'>All my SGBT purchases</h4>
      <b-row class=''>
        <b-col cols=12>
          <div v-if="getBuyByUser.length === 0" style="background-color: #1e1e1e; height: 135px; display: flex; justify-content: center; align-items: center;">
            <h6 class='mb-0 txt-color-primary'>The list is empty</h6>
          </div>
          <b-list-group flush>
            <b-list-group-item
              button
              style='background: none;'
              class='p-0 mb-2'
              v-for="(item, index) in getBuyByUser" v-bind:key="index"
            >
              <b-card no-body class='p-2 pt-4'>
                <b-container>
                  <b-row class='box'>
                    <b-col cols=2  class='pt-sm-0' style='padding: 2px 0px 0px 0px;'>
                      <div class='icon'>
                        <div class='wraper'>
                          <component
                            :is="getAsset(item.symbol).component"
                            v-bind="{width: 25,height: 25,fill: '#FFF9BC'}"
                          />
                        </div>
                      </div>
                    </b-col>
                    <b-col cols=10 class=''>
                      <b-row>
                        <b-col cols=12 sm=6 class='txt-color-secondary'>
                          <h5 class='font-weight-bold'>SGBT-{{item.symbol}}</h5>
                        </b-col>
                        <b-col cols=12 sm=6 style='color: #A7A4A4' class='text-left text-sm-right'>
                          <h6>{{ getRegistro(item.block_timestamp)}}</h6>
                        </b-col>
                        <!---->
                        <b-col cols=12 sm=5 class='txt-color-secondary text-left'>
                          <h6>Price: <strong>{{item.price}} USD</strong></h6>
                        </b-col>
                        <b-col cols=12 sm=7 class='txt-color-primary text-left text-sm-right pl-sm-0'>
                          <h6 class='mb-0' >{{item.sgb}}<strong class="pl-1">SGBT</strong></h6>
                          <h6 style="color: #A7A4A4; font-size: 0.8rem;"> Cost: <strong>{{item.cost}} USD</strong></h6>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-container>
              </b-card>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col cols=12 class='text-right mt-2'>
          <b-button class = "btn-sm" style="height: 27px;" variant="primary">+</b-button>
        </b-col>
      </b-row>
      <!-- list all withdraw SGBT-->
      <h4 class='txt-color-secondary py-4'>All SGBT withdrawals</h4>
      <b-row class='mt-2'>
        <ListSimpleBuy :items='getAllWithdraw'/>
      </b-row>
      <!-- list mis withdraw SGBT-->
      <h4 class='txt-color-secondary py-4'>All my SGBT withdrawals</h4>
      <b-row class='mt-2'>
        <ListSimpleBuy :items='getWithdrawByUser'/>
      </b-row>
      <!-- recompensas -->
      <h4 class='txt-color-secondary py-4'>
        Rewards Status
        <span class='ml-0 ml-sm-3'>
          <b-button @click="shareLink()" class="btn-sm" variant="primary">Share</b-button>
        </span>
      </h4>
      <b-row>
        <b-col
          cols=12 sm=6 md=6
          class='mb-2'
          v-for='(item, index) in getRecompensas("TRX")' v-bind:key="index"
        >
          <BalanceItem :item='item'/>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols=12 sm=6 md=6
          class='mb-2'
          v-for='(item, index) in getRecompensas("USDT")' v-bind:key="index"
        >
          <BalanceItem :item='item'/>
        </b-col>
      </b-row>
      <!-- Withdrawn -->
      <div class='py-4' style='display: flex;'>
        <h4 class="txt-color-secondary">
          Withdraw
          <span class=''>
            <b-button @click="Withdraw('TRX')" class="ml-3 btn-sm" style='width: 70px;' variant="primary">TRX</b-button>
            <b-button @click="Withdraw('USDT')" class="ml-3 btn-sm" style='width: 70px;' variant="primary">USDT</b-button>
          </span>
        </h4>
      </div>
      <b-row class='mt-2'>
        <ListSimpleBuy :items='getAllWithdrawRef'/>
      </b-row>

      <b-modal id='share-info-id' class='' ref='share-info-id' hide-header hide-footer centered>
        <b-container fluid>
          <b-row class="mt-4">
            <b-col cols=12>
                <b-row  class="">
                    <b-col cols=3 class='text-center'>
                        <b-row>
                          <div class="wrapper">
                            <div class = "img">
                              <UserIcon/>
                              <h5>{{ ID }}</h5>
                            </div>
                          </div>
                        </b-row>
                    </b-col>
                    <b-col cols=9>
                      <h5>Rewards</h5> <!-- recompensas: Reciba del 10 al 15% de las compras realizadas a través de este enlace.-->
                      <p>Receive 10% of purchases made through this link.</p>
                    </b-col>
                </b-row>
                <!-- link -->
                <div class='my-3'>
                  <mi-link titulo="link" :valor="this.getLink"/>
                </div>
            </b-col>
          </b-row>
        </b-container>
      </b-modal >

      <b-modal id="publicidad-id" ref="publicidad-id" size="lg" hide-header hide-footer centered body-class="p-0">
        <div class="publicidad">
        </div>
        <div class="description">
          <b-container fluid class="h-100">
            <b-row align-v="center" class="h-100">
              <b-col cols=12 class="text-center">
                <h3>EARN 10% IN TRX USDT PER REFERAL ON SGBT'S PRE SALE</h3>
                <br>
                <br>
                <h1>START EARNING TODAY</h1>
                <br>
                <br>
                <div>
                  <button @click.stop.prevent="copiar"
                  style = "border: 1px solid #fedc57ff !important; border-radius: 10px !important; padding: 10px; margin: auto; color: #black; background-color: #f9b707;"
                  >GET YOUR REFERRAL LINK </button>
                  <input type="hidden" ref="myLink" :value="this.getLink">
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-modal>
      <div style="height: 100px"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ApiWallet from '@/services/ApiWallet.service'
import AssetsItem from '@/components/presale/assets/assetsItem'
import SimpleItem from '@/components/presale/assets/simpleItem'
import ListSimpleBuy from '@/components/presale/assets/listSimpleBuy'
import BalanceItem from '@/components/presale/assets/recompensas/balanceItem'
import UserIcon from '@/components/icons/UserIcon'
import MiLink from '@/components/presale/MiLink'
// iconos
import TronIcon from '@/components/icons/TronIcon'
import TeterIcon from '@/components/icons/TeterIcon'
import SmartGlobalIcon from '@/components/icons/SmartGlobalIcon'
import { required } from 'vuelidate/lib/validators'
export default {
  components: {
    AssetsItem,
    SimpleItem,
    BalanceItem,
    ListSimpleBuy,
    UserIcon,
    MiLink
  },
  data () {
    return {
      userId: 0,
      smartInfinity: {
        isRegistered: false
      },
      partner: {
        id: 0
      },
      buyByUser: [],
      buyByPair: [],
      allBuyByPairAddress: [], // todas las compras por par selecionado y direccion dentro del contrato
      withdrawAll: [],
      withdrawByUser: [],
      withdrawAllRef: [],
      balances: [
        {
          symbol: 'TRX',
          value: 0,
          price: '--'
        },
        {
          symbol: 'USDT',
          value: 0,
          price: '--'
        },
        {
          symbol: 'SGBT',
          value: 0,
          price: '--'
        }
      ],
      assets: {
        trc10: [
          {
            component: TronIcon,
            properties: {
              width: 25,
              height: 25,
              fill: '#FFF9BC'
            },
            name: 'TRON',
            symbol: 'TRX',
            id: 0,
            balance: 0,
            price: '--',
            precision: 6
          }
        ],
        trc20: [
          {
            component: TeterIcon,
            properties: {
              width: 25,
              height: 25,
              fill: '#FFF9BC'
            },
            name: 'Tether Token',
            symbol: 'USDT',
            address: 'TBfTHz4oDkjBR8TafHKGqzGkuyQvCGdXJF',
            balance: 0,
            price: '--',
            precision: 6
          },
          {
            component: SmartGlobalIcon,
            properties: {
              width: 25,
              height: 25,
              fill: '#FFF9BC'
            },
            name: 'Smart Global Token',
            symbol: 'SGBT',
            address: 'TCdCXwD9GPmJUVaB64KeGU6ovd34XgFNe7',
            balance: 0,
            price: '--',
            precision: 9
          }
        ]
      },
      distribution: {
        supply: 0,
        available: 0,
        balance: 0,
        buy: 0
      },
      recompensas: [
        {
          symbol: 'TRX',
          balance: 0,
          withdrawn: 0
        },
        {
          symbol: 'USDT',
          balance: 0,
          withdrawn: 0
        }
      ],
      selected: 'SGBT/TRX',
      pairs: [
        { display: 'SGBT/TRX', value: 'SGBT/TRX', text: 'SGBT/TRX', show: true },
        { display: 'SGBT/USD', value: 'SGBT/USDT', text: 'SGBT/USD', show: true },
        { display: 'TRX/USD', value: 'TRX/USDT', text: 'TRX/USD', show: false }
      ],
      prices: [
        { pair: 'TRX/USD', value: 0 },
        { pair: 'SGBT/USDT', value: 0 },
        { pair: 'SGBT/TRX', value: 0 }
      ],
      rangoUSD: {
        min: 10.01,
        max: 3000
      },
      rangoSGB: {
        min: 0,
        max: 0
      },
      form: {
        SGB: 0,
        TRX: 0,
        USD: 0,
        update: false,
        partner: 0,
        onlyUSDT: false,
        // --
        withdrawStatus: false,
        withdrawIsEnabled: false,
        blackListStatus: false,
        withdrawPercentage: 0,
        withdrawalCompleted: false
      },
      errorMessages: {
        required: 'this amount is required.'
      },
      tronGrid: null,
      smartContrac: {
        instance: null,
        instanceUSDT: null,
        instanceSGB: null,
        instanceSI: null,
        error: false,
        balance: 0,
        balanceUSDT: 0,
        balanceTRX: 0,
        supply: 0,
        address: '', // SGBT PRESALE
        siAddress: '', // smart infinity
        trc20: {
          usdtAddress: '',
          sgbAddress: ''
        },
        buyAll: [],
        allBuyUSDT: [],
        buyUSDT: [],
        withdraw: []
      }
    }
  },
  validations: {
    form: {
      TRX: {
        required,
        maxTRX: function (value) {
          const balance = this.balances[0].value / Math.pow(10, 6)
          if (this.selected === 'SGBT/TRX') {
            if (balance === 0) {
              this.errorMessages.maxTRX = 'Balance is zero'
              return false
            }
            if (value > balance) {
              this.errorMessages.maxTRX = 'MAX ' + balance + ' TRX'
              return false
            }
          }
          return true
        }
      },
      USD: {
        required,
        maxUSD: function (value) {
          const balance = this.balances[1].value / Math.pow(10, 6)
          if (this.selected === 'SGBT/USDT') {
            if (balance === 0) {
              this.errorMessages.maxUSD = 'Balance is zero'
              return false
            }
            if (value > balance) {
              this.errorMessages.maxUSD = 'MAX ' + balance + ' USDT'
              return false
            }
          }
          return true
        }
      },
      SGB: {
        required,
        minValue: function (value) {
          if (value === 0) {
            return false
          }
          return value >= this.rangoSGB.min
        },
        maxValue: function (value) { return value <= this.rangoSGB.max }
      }
    }
  },
  computed: {
    ...mapGetters({
      getUserAddress: 'getAddress',
      walletIsInstalled: 'walletIsInstalled',
      getStatusAuthWallet: 'auth/getStatusAuthWallet',
      getOptionsAuthWallet: 'auth/getOptionsAuthWallet'
    }),
    updateFormTRX: {
      get: function () { return this.form.TRX },
      set: function (trx) {
        this.form.TRX = trx
        this.form.USD = this.formatter(trx * this.prices[0].value, 6)
        this.form.SGB = this.formatter(Number(trx) !== 0 ? trx / this.prices[2].value : 0, 9)
        this.$v.form.$touch()
      }
    },
    updateFormSGB: {
      get: function () { return this.form.SGB },
      set: function (sgb) {
        this.form.SGB = sgb
        this.form.USD = this.formatter(sgb * this.prices[1].value, 6)
        this.form.TRX = this.formatter((this.prices[2].value !== 0) ? sgb * this.prices[2].value : 0, 6)
        this.$v.form.$touch()
      }
    },
    updateFormUSD: {
      get: function () { return this.form.USD },
      set: function (usd) {
        this.form.USD = usd
        this.form.TRX = this.formatter((this.prices[0].value !== 0) ? usd / this.prices[0].value : 0, 6)
        this.form.SGB = this.formatter((this.prices[1].value !== 0) ? usd / this.prices[1].value : 0, 9)
        this.$v.form.$touch()
      }
    },
    ID () { return this.userId.toString().padStart(3, 0) },
    getLink () { return 'https://dashboard.sgbtoken.com/#/presale/ref/' + this.userId },
    getAllBuyUSDT () { return this.smartContrac.allBuyUSDT },
    getBuyUSDT () { return this.smartContrac.buyUSDT },
    getWithdraw () { return this.smartContrac.withdraw },
    /* borrar */
    getAssets () {
      return [
        ...this.assets.trc10,
        ...this.assets.trc20
      ]
    },
    getBalances () {
      const balances = []
      let details = this.getAsset('TRX')
      balances[0] = {
        symbol: details.symbol,
        name: details.name,
        component: details.component,
        properties: details.properties,
        value: this.GLOBAL._toDecimal(this.balances[0].value, details.precision),
        price: this.balances[0].price
      }
      // USDT
      details = this.getAsset('USDT')
      balances[1] = {
        symbol: details.symbol,
        name: details.name,
        component: details.component,
        properties: details.properties,
        value: this.GLOBAL._toDecimal(this.balances[1].value, details.precision),
        price: this.balances[1].price
      }
      // SGBT
      details = this.getAsset('SGBT')
      balances[2] = {
        symbol: details.symbol,
        name: details.name,
        component: details.component,
        properties: details.properties,
        value: this.GLOBAL._toDecimal(this.balances[2].value, details.precision),
        price: this.balances[2].price
      }
      return balances
    },
    getRecompensas: function () {
      const vm = this
      return (symbol) => {
        const assets = [
          ...vm.assets.trc10,
          ...vm.assets.trc20
        ]
        // add icon
        const recompensas = this.recompensas.find(item => item.symbol === symbol)
        const asset = assets.find(item => item.symbol === symbol)
        const properties = asset
        properties.fill = '#1E1E1E'
        return [
          {
            symbol: recompensas.symbol,
            title: 'Balance',
            value: recompensas.balance,
            component: asset.component,
            properties: properties
          },
          {
            symbol: recompensas.symbol,
            title: 'Withdrawn',
            value: recompensas.withdrawn,
            component: asset.component,
            properties: properties
          }
        ]
      }
    },
    getDistribution () {
      return [
        {
          title: 'Supply',
          value: this.GLOBAL._toDecimal(this.distribution.supply, 9),
          symbol: 'SGBT'
        },
        {
          title: 'Available',
          value: this.GLOBAL._toDecimal(this.distribution.available, 9),
          symbol: 'SGBT'
        },
        {
          title: 'Balance',
          value: this.GLOBAL._toDecimal(this.distribution.balance, 9),
          symbol: 'SGBT'
        },
        {
          title: 'Buy',
          value: this.GLOBAL._toDecimal(this.distribution.buy, 9),
          symbol: 'SGBT'
        }
      ]
    },
    /* get all buy in contract */
    getAllBuy () { return this.smartContrac.buyAll },
    /* get all buy by pair in contract */
    getBuyByPair () { return this.buyByPair },
    /* get all buy by pair and address in contract */
    getBuyByUser () { return this.buyByUser },
    /* get all withdraw SGBT in contract */
    getAllWithdraw () { return this.withdrawAll },
    /* get all withdraw by user in contract */
    getWithdrawByUser () { return this.withdrawByUser },
    /* get all withdraw TRX USDT in contract */
    getAllWithdrawRef () { return this.withdrawAllRef },
    formOnlyUSDT () { return this.form.onlyUSDT }
  },
  watch: {
    async getStatusAuthWallet (_new, old) {
      console.log('getStatusAuthWallet: ', { old, _new })
      console.log('walletIsInstalled', this.$store.getters.walletIsInstalled)
      if (this.$store.getters.walletIsInstalled) {
        // logged in
        if (old === this.getOptionsAuthWallet.LOGGING_IN &&
          _new === this.getOptionsAuthWallet.LOGGED_IN
        ) {
          this.loggenIn()
        } else {
          // NOT LOGGED IN
          if (old === this.getOptionsAuthWallet.LOGGING_IN && _new === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
            this.notLoggedIn()
          }
        }
      } else {
        // NOT LOGGED IN
        if (_new === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
          this.notLoggedIn()
        }
      }
    }
  },
  async created () {
    const env = {
      pro: {
        address: {
          presale: 'THExGDQ6fnjf1VSUvJNjvmN4z8VhQqaZsC',
          smartInfinity: 'TSFLpvYrCwsMSUQgdd5H3pn5U5z2D1ASg4',
          usdt: 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t',
          sgb: 'TCdCXwD9GPmJUVaB64KeGU6ovd34XgFNe7'
        }
      },
      dev: {
        address: {
          presale: 'TZ9HkvNQk19MZ6zHaYDcBAyYwghvzsd1qq',
          smartInfinity: 'TMytwgDdp5dKvhEJJdg8HQVVKKzfuJm3hD',
          usdt: 'TXLAQ63Xg1NAzckPwKHvzw7CSEmLMEqcdj',
          sgb: 'TYXv6PK6hsRY5mfekPZnBjs1JHaggbvaRh'
        }
      }
    }

    const setup = env.pro
    this.smartContrac.address = setup.address.presale
    this.smartContrac.siAddress = setup.address.smartInfinity
    this.smartContrac.trc20.usdtAddress = setup.address.usdt
    this.smartContrac.trc20.sgbAddress = setup.address.sgb

    this.update()
  },
  async updated () { },
  methods: {
    copiar (e) {
      console.log('copiado')
      const testingCodeToCopy = this.$refs.myLink // document.querySelector('.group-link #testing-code')
      testingCodeToCopy.setAttribute('type', 'text') // hidden
      testingCodeToCopy.select()
      try {
        var successful = document.execCommand('copy')
        var msg = successful ? 'successful' : 'unsuccessful'
        console.log('copiar ' + msg)
      } catch (err) {
        console.log('Oops, unable to copy')
      }
      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
      this.$refs['publicidad-id'].hide()
    },
    formatter (value, max) {
      const split = value.toString().split('.')
      if (split.length === 2) {
        if (split[1].length > max) {
          const temp = split[0] + '.' + split[1].substring(0, max)
          return temp
        }
      }
      return value
    },
    formatter_6 (value) { return this.formatter(value, 6) },
    formatter_9 (value) { return this.formatter(value, 9) },
    /**
    * returns true only if the address has made a purchase in the presale.
    **/
    isRegistered () { return this.userId > 0 },
    async isSmartInfinity () {
      await this.smartContrac.instanceSI.users(this.getUserAddress).call()
        .then(resp => {
          if (this.tronGrid.tronWeb.toDecimal(resp.id._hex) !== 0) {
            this.rangoUSD.min = 10.01
            this.smartInfinity.isRegistered = true
            console.log('SI', this.smartInfinity.isRegistered)
          }
        })
        .catch(e => console.log({ e }))
    },
    /*
    * establece la sociedad entre dos compradores
    * segun url
    */
    async setPartner () {
      this.partner = {
        id: 0
      }
      const split = await this.$route.fullPath.split('/')
      if (split[1] && split[1] === 'presale') {
        if (split[2] && split[2] === 'ref') {
          if (split[3] && split[3] !== '' && Number.isInteger(Number(split[3]))) {
            this.partner.id = Number(split[3])
          }
        }
      }
      console.log('partner', this.partner)
    },
    shareLink () {
      if (this.getStatusAuthWallet === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
        this.$notificacionSimple('ERROR', 'Connects to wallet')
        return
      }
      if (!this.isRegistered()) {
        this.$notificacionSimple('ERROR', 'Unregistered address')
        return
      }
      this.$refs['share-info-id'].show()
      console.log('shareLink')
    },
    setForm () {
      this.form.TRX = 0
      this.form.USD = 0
      this.form.SGB = 0
    },
    cls () {
      this.partner.id = 0
      //
      this.setForm()
      //
      this.rangoUSD.min = 10.01
      this.smartInfinity.isRegistered = false

      this.balances.forEach(item => {
        item.value = 0
        item.price = '--'
      })
      this.distribution.supply = 0
      this.distribution.available = 0
      this.distribution.balance = 0
      this.distribution.buy = 0
      this.smartContrac.buyAll = []
      this.buyByUser = []
      this.withdrawAll = []
      this.withdrawByUser = []
      this.recompensas.forEach(item => {
        item.balance = 0
        item.withdrawn = 0
      })
      this.withdrawAllRef = []
    },
    async loggenIn () {
      console.log('LOGGED_IN')
      this.$store.commit('setLoading', true)
      try {
        this.cls()
        this.tronGrid = new ApiWallet()
        this.tronGrid.tronWeb.setAddress(this.getUserAddress)
        await this.getContractAssets()
        if (!this.smartContrac.error) {
          await this.updateALL()
        }
      } catch (e) { console.log({ e }) }
      this.$store.commit('setLoading', false)
    },
    async notLoggedIn () {
      this.$store.commit('setLoading', true)
      try {
        console.log('NOT_LOGGED_IN')
        this.cls()
        this.tronGrid = new ApiWallet()
        // this.tronGrid.setAddress(this.getUserAddress)
        await this.getContractAssets()
        if (!this.smartContrac.error) {
          await this.updateWithExtension()
        }
      } catch (e) { console.log({ e }) }
      this.$store.commit('setLoading', false)
    },
    async update () {
      if (this.$store.getters.walletIsInstalled) {
        if (this.getStatusAuthWallet === this.getOptionsAuthWallet.LOGGED_IN) {
          this.loggenIn()
        } else {
          if (this.getStatusAuthWallet === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
            this.notLoggedIn()
          }
        }
      } else {
        // NOT LOGGED IN
        if (this.getStatusAuthWallet === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
          this.notLoggedIn()
        }
      }
    },
    getTitleBTN () {
      if (this.getBase() === 'USDT' && !this.form.onlyUSDT) {
        return 'APPROVE'
      }
      return 'BUY'
    },
    async updateALL () {
      //
      await this.setBalancesAssets()
      // update default
      await this.updateWithExtension()
      //
      await this.setAllowance()
      //
      await this.setAccountDetails()
      //
      await this.isSmartInfinity()
      //
      this.setRangoSGB()
      //
      if (this.isRegistered()) {
        await this.setWithdrawIsEnabled()
        await this.setBuyByUser()
        await this.setWithdrawByUser()
        this.$refs['publicidad-id'].show()
      } else {
        //
        console.log(' not Registered')
        await this.setPartner()
      }
      this.$v.form.$touch()
    },
    async updateWithExtension () {
      //
      await this.setStatus()
      //
      await this.setAllBuy()
      //
      await this.setWithdrawAll()
      //
      await this.setAllWithdrawRef()
    },
    validateState (item) {
      const { $dirty, $error } = item
      return $dirty ? !$error : null
    },
    getErrorMessage (item) {
      if (item.$error) {
        for (const key in item.$params) {
          if (item[key] === false) {
            return this.errorMessages[key]
          }
        }
      }
      return null
    },
    getRegistro (timestamp) { return new Date(timestamp).toLocaleString() },
    pair (selected) { this.selected = selected },
    pairDisplay (pair) { return this.pairs.find(item => item.value === pair).display },
    getBase () {
      const symbol = this.selected.split(/\s*\/\s*/)
      return symbol[1]
    },
    display2 () {
      const symbol = this.selected.split(/\s*\/\s*/)
      return symbol[0] + ' with ' + symbol[1]
    },
    price (value) {
      return this.prices.find(item => item.pair === value).value
    },
    // borrar
    getAssetTRC10 (symbol) { return this.assets.trc10.find(item => item.symbol === symbol) },
    // borrar
    getAssetsTRC20 (symbol) { return this.assets.trc20.find(item => item.symbol === symbol) },
    getAsset (symbol) {
      const assets = [
        ...this.assets.trc10,
        ...this.assets.trc20
      ]
      return assets.find(item => item.symbol === symbol)
    },
    async onSubmit (event) {
      const vm = this
      console.log({ selected: vm.selected })
      // validator
      vm.$v.form.$touch()
      if (vm.$v.form.$anyError) {
        return
      }
      if (this.tronGrid.readOnly) {
        vm.$notificacionSimple('Error', 'read-only connections.')
        return
      }
      const confirm = await vm.$notificacionSimpleConfirm('Notification', 'Purchases take 1-5 minutes to complete. Do you wish to continue?') // ES : Las compras tardan de 1 a 5 minutos en completarse. ¿Desea continuar?
      console.log('confirm', confirm)
      if (!confirm) {
        return
      }
      // this.partner.id = 0
      this.$store.commit('setLoading', true)
      event.preventDefault()
      // Buy
      const mult = Math.pow(10, 6)
      const buy = async () => {
        const options = {
          feeLimit: 100 * mult,
          callValue: 0,
          shouldPollResponse: true
        }
        // usdt
        if (vm.selected === 'SGBT/USDT') {
          const value = Number(vm.form.USD).toFixed(6) * mult
          if (!vm.form.onlyUSDT) {
            return await vm.smartContrac.instanceUSDT.approve(vm.smartContrac.address, value).send(options)
          } else {
            if (!vm.isRegistered() && vm.smartInfinity.isRegistered) {
              return await vm.smartContrac.instance.buySI_SGBUSDT(this.partner.id, value).send(options)
            }
            return await vm.smartContrac.instance.buySGBUSDT(this.partner.id, value).send(options)
          }
        }
        // buy with trx
        if (vm.selected === 'SGBT/TRX') {
          console.log({ trx: vm.form.TRX, id: this.partner.id })
          options.callValue = Number(vm.form.TRX).toFixed(6) * mult
          if (!vm.isRegistered() && vm.smartInfinity.isRegistered) {
            return await vm.smartContrac.instance.buySI_SGBTRX(this.partner.id).send(options)
          }

          return await vm.smartContrac.instance.buySGBTRX(this.partner.id).send(options)
        }
      }
      await buy()
        .then(async () => {
          vm.$store.commit('setLoading', false)
          await vm.$notificacionSimple('success', 'The operation was successful.')
        }).catch(async (e) => {
          console.log('error', { e })
          vm.$store.commit('setLoading', false)
          await vm.$notificacionSimple('Error', (e.error) ? e.error : e)
        })
      this.setForm()
      this.$store.commit('setLoading', true)
      await this.updateALL()
      this.$store.commit('setLoading', false)
    },
    async buy (event) {
      console.log('buy')
      await this.smartContrac.instance.buySGBUSDT(
        this.smartContrac.allowanceSGBUSDT
      ).send({
        feeLimit: 1000000000,
        callValue: 0,
        shouldPollResponse: true
      }).then(resp => {
        console.log('resp', resp)
      }).catch(error => {
        let err = null
        let message = ''
        if (error.error === undefined) {
          if (error === 'Confirmation declined by user') {
            err = error
            message = 'Confirmation declined by user'
          }
        } else {
          err = error.error
          if (err === 'REVERT opcode executed') {
            message = this.tronGrid.tronWeb.toUtf8(error.output.contractResult[0]).replace(/[^a-zA-Z .]/g, '')
            message = message.replace(/[^a-zA-Z]/g, '.')

            console.log('error.message:' + message + '.')
          } else {
            message = error.message
          }
        }
        console.log('message', message)
      })
    },
    async retirar () {
      console.log('retirar')
      // Retirar
      await this.smartContrac.instance.withdrawAll()
        .send({
          feeLimit: 1000000000,
          callValue: 0,
          shouldPollResponse: false
        }).then(resp => {
          console.log('resp', resp)
        }).catch(error => {
          let err = null
          let message = ''
          if (error.error === undefined) {
            if (error === 'Confirmation declined by user') {
              err = error
              message = 'Confirmation declined by user'
            }
          } else {
            err = error.error
            if (err === 'REVERT opcode executed') {
              message = this.tronGrid.tronWeb.toUtf8(error.output.contractResult[0]).replace(/[^a-zA-Z .]/g, '')
              message = message.replace(/[^a-zA-Z]/g, '.')

              console.log('error.message:' + message + '.')
            } else {
              message = error.message
            }
          }
          console.log('message', message)
        })
    },
    async Withdraw (symbol) {
      // es: El retiro no fue posible
      const messageError = 'Withdrawal was not possible.'
      const vm = this
      if (this.getStatusAuthWallet === this.getOptionsAuthWallet.NOT_LOGGED_IN) {
        this.$notificacionSimple('ERROR', 'Connects to wallet')
        return
      }
      if (!this.form.withdrawStatus) {
        this.form.withdrawStatus = true
        const withdraw = async function () {
          const options = {
            feeLimit: 100000000,
            callValue: 0,
            shouldPollResponse: true
          }
          if (symbol === 'TRX') {
            return new Promise((resolve, reject) => {
              if (vm.form.blackListStatus) {
                reject(new Error('Address is evil')) // es: la direccion es malvada
              } else {
                if (vm.recompensas[0].balance <= 0) {
                  reject(new Error('Balance is zero')) // es: saldo sgb es cero
                } else {
                  vm.$notificacionSimpleConfirm('Notification', 'Withdrawals take 1-5 minutes to complete.')
                    .then(async (resp) => {
                      if (!resp) {
                        reject(new Error('cancel'))
                      } else {
                        vm.$store.commit('setLoading', true)
                        await vm.smartContrac.instance.withdrawTRX().send(options)
                          .then(resp => resolve(resp))
                          .catch(error => reject(error))
                        vm.$store.commit('setLoading', false)
                      }
                    }).catch(e => reject(e))
                }
              }
            })
          }
          if (symbol === 'USDT') {
            return new Promise((resolve, reject) => {
              if (vm.form.blackListStatus) {
                reject(new Error('Address is evil')) // es: la direccion es malvada
              } else {
                if (vm.recompensas[1].balance <= 0) {
                  reject(new Error('Balance is zero')) // es: saldo sgb es cero
                } else {
                  vm.$notificacionSimpleConfirm('Notification', 'Withdrawals take 1-5 minutes to complete.') // es: los retiros tardan entre 1 y 5 minutos en completarse
                    .then(async (resp) => {
                      if (!resp) {
                        reject(new Error('cancel'))
                      } else {
                        vm.$store.commit('setLoading', true)
                        await vm.smartContrac.instance.withdrawUSDT().send(options)
                          .then(resp => resolve(resp))
                          .catch(error => reject(error))
                        vm.$store.commit('setLoading', false)
                      }
                    }).catch(e => reject(e))
                }
              }
            })
          }
          // SGBT
          return new Promise((resolve, reject) => {
            if (!vm.form.withdrawIsEnabled) {
              reject(new Error('Withdrawal of funds is not enabled')) // es: El retiro de fondos no esta habilitado
            } else {
              if (vm.form.blackListStatus) {
                reject(new Error('Address is evil')) // es: la direccion es malvada
              } else {
                if (vm.form.withdrawalCompleted) {
                  reject(new Error('Withdrawal completed')) // es: retiro completado
                } else {
                  if (vm.distribution.balance <= 0) {
                    reject(new Error('Balance SGBT is zero')) // es: saldo sgb es cero
                  } else {
                    vm.$notificacionSimpleConfirm('Notification', 'Enabled ' + vm.form.withdrawPercentage + ' % ,Withdrawals take 1-5 minutes to complete.') // es: los retiros tardan entre 1 y 5 minutos en completarse
                      .then(async (resp) => {
                        console.log('confirm', { resp })
                        if (!resp) {
                          reject(new Error('cancel'))
                        } else {
                          vm.$store.commit('setLoading', true)
                          await vm.smartContrac.instance.withdraw().send(options)
                            .then(resp => resolve(resp))
                            .catch(e => reject(e))
                          vm.$store.commit('setLoading', false)
                        }
                      }).catch(e => reject(e))
                  }
                }
              }
            }
          })
        }
        await withdraw()
          .then(resp => {
            console.log('resp', resp)
            // es: Retiro de fondos completado
            vm.$notificacionSimple('SUCCESS', 'Withdrawal of funds completed.')
          }).catch(e => {
            console.log('error', { e })
            if (e.message !== 'cancel') {
              const message = e.message ? e.message : e
              vm.$notificacionSimple('ERROR', messageError + ' ' + message)
            }
          })
        this.updateALL()
        this.form.withdrawStatus = false
      } else {
        // es: hay un retiro de fondos en proceso
        vm.$notificacionSimple('Notification', 'There is a withdrawal of funds in process.')
      }
    },
    setBalance (symbol, value) {
      this.balances.find(item => {
        if (item.symbol === symbol) {
          item.value = (value !== undefined) ? value : 0
          return item
        }
      })
    },
    async getContractAssets () {
      try {
        if (this.smartContrac.instanceUSDT === null) {
          this.smartContrac.instanceUSDT = await this.tronGrid.getContract(this.smartContrac.trc20.usdtAddress)
        }
        //
        if (this.smartContrac.instanceSGB === null) {
          this.smartContrac.instanceSGB = await this.tronGrid.getContract(this.smartContrac.trc20.sgbAddress)
        }
        /* SC presale */
        if (this.smartContrac.instance === null) {
          this.smartContrac.instance = await this.tronGrid.getContract(this.smartContrac.address)
        }
        /* SC smart infinity */
        if (this.smartContrac.instanceSI === null) {
          this.smartContrac.instanceSI = await this.tronGrid.getContract(this.smartContrac.siAddress)
        }
      } catch (e) {
        this.smartContrac.instanceUSDT = null
        this.smartContrac.instanceSGB = null
        this.smartContrac.instance = null
        this.smartContrac.instanceSI = null
        this.smartContrac.error = true
        console.log('error: getContractAssets', { e })
      }
    },
    /* SGBT withdraw Is Enabled */
    async setWithdrawIsEnabled () {
      // get Status
      this.form.withdrawIsEnabled = await this.smartContrac.instance.WithdrawStatus().call() // disponible?
      this.form.blackListStatus = await this.smartContrac.instance.getBlackListStatus(this.getUserAddress).call()
      if (this.form.withdrawIsEnabled) {
        if (!this.form.blackListStatus) {
          this.form.withdrawalCompleted = await this.smartContrac.instance._listWithdraw(this.getUserAddress).call() // withdraw completado
          if (!this.form.withdrawalCompleted) {
            this.form.withdrawPercentage = await this.smartContrac.instance.withdrawPercentage().call() // %
          }
        }
      }
    },
    /* set fondos */
    async setBalancesAssets () {
      /* TRX */
      const account = await this.tronGrid.getAccount()
      this.setBalance('TRX', account.balance)
      // USDT get address balance
      let balance = await this.tronGrid.balanceOf(
        this.smartContrac.instanceUSDT,
        this.getUserAddress
      )
      this.setBalance('USDT', balance)
      // SGBT get address balance
      balance = await this.tronGrid.balanceOf(
        this.smartContrac.instanceSGB,
        this.getUserAddress
      )
      this.setBalance('SGBT', balance)
      // pre venta
      balance = await this.smartContrac.instance.balanceOf(this.getUserAddress).call()
      this.distribution.balance = this.tronGrid.tronWeb.toDecimal(balance._hex)
    },
    setPrices (status) {
      this.prices[0].value = Number(this.GLOBAL._toDecimal(this.tronGrid.tronWeb.toDecimal(status._priceTRXUSD._hex), 6))
      this.prices[1].value = Number(this.GLOBAL._toDecimal(this.tronGrid.tronWeb.toDecimal(status._priceSGBUSD._hex), 6))
      this.prices[2].value = (this.prices[1].value !== 0) ? this.prices[1].value / this.prices[0].value : 0
      this.prices[2].value = Number(this.prices[2].value).toFixed(6)
    },
    setRangoSGB () {
      console.log('this.prices[1].value: ', this.prices[1].value)
      this.rangoSGB.min = (this.prices[1].value !== 0) ? this.rangoUSD.min / this.prices[1].value : 0
      this.rangoSGB.max = (this.prices[1].value !== 0) ? this.rangoUSD.max / this.prices[1].value : 0
      console.log('this.rangoSGB.min: ', this.rangoSGB.min)
      // set error
      this.errorMessages.minValue = ' MIN ' + this.rangoSGB.min + ' SGBT'
      this.errorMessages.maxValue = ' MAX ' + this.rangoSGB.max + ' SGBT'

      const available = Number(this.GLOBAL._toDecimal(this.distribution.available, 9))
      if (available < this.rangoSGB.max) {
        this.errorMessages.maxValue = ' MAX ' + available + ' SGBT'
        this.rangoSGB.max = available
      }
    },
    async setStatus () {
      // get Status
      const status = await this.smartContrac.instance.status().call()
      this.distribution.supply = this.tronGrid.tronWeb.toDecimal(status._supply._hex)
      this.distribution.available = this.tronGrid.tronWeb.toDecimal(status.balance._hex)
      this.distribution.buy = this.distribution.supply - this.distribution.available
      // set prices
      this.setPrices(status)
    },
    /* todas las compras realizadas */
    async setAllBuy () {
      try {
        // get events _buySGBUSD
        const event = await this.tronGrid.getEventByContract(this.smartContrac.address, '_buyUSD')
        const events = []
        event.data.data.forEach(element => {
          const item = {
            id: element.transaction_id,
            block_timestamp: element.block_timestamp,
            price: element.result.SGBUSD,
            sgb: 0, // this.GLOBAL._toDecimal(element.result.sgb, 9),
            cost: this.GLOBAL._toDecimal(element.result.USD, 6)
          }
          const cost = Number(item.cost.toString().replace(',', ''))
          item.sgb = this.GLOBAL._toDecimal(parseInt(cost * Math.pow(10, 15) / item.price, 10), 9)
          events.push(item)
        })
        this.smartContrac.buyAll = events
      } catch (e) { console.log({ e }) }
    },
    /* todas las compras por direccion de usuario */
    async setBuyByUser () {
      //
      const options = {
        only_confirmed: false,
        only_unconfirmed: false,
        only_to: true,
        limit: 20,
        contract_address: this.smartContrac.address
      }
      const compras = []
      this.buyByUser = []
      try {
        await this.tronGrid.getTransactionsTRC20(
          this.getUserAddress,
          options
        ).then(async resp => {
          for (const element of resp.data.data) {
            const compra = {
              id: -1,
              block_timestamp: 0,
              price: 0,
              cost: 0,
              sgb: 0,
              symbol: 'USDT'
            }
            try {
              compra.id = element.transaction_id
              compra.block_timestamp = element.block_timestamp
              compra.sgb = this.GLOBAL._toDecimal(element.value, 9)

              const event = await this.tronGrid.getEventByID(element.transaction_id)
              for (const item of event.data.data) {
                // set precio y cantidad sgb
                if (item.event_name === '_buySGBTRX') {
                  compra.symbol = 'TRX'
                } else {
                  if (item.event_name === '_buyUSD') {
                    compra.price = this.GLOBAL._toDecimal(item.result.SGBUSD, 6)
                    compra.cost = this.GLOBAL._toDecimal(item.result.USD, 6)
                  } else {
                    if (item.event_name === 'Transfer') {
                      // compra.sgb = this.GLOBAL._toDecimal(item.result.value, 9)
                    }
                  }
                }
              }
            } catch (e) { console.log('e', e) }
            // add
            compras.push(compra)
          }
          this.buyByUser = compras
        }).catch(e => Promise.reject(e))
      } catch (e) { console.log({ e }) }
    },
    async setWithdrawAll () {
      try {
        const event = await this.tronGrid.getEventByContract(this.smartContrac.address, 'eventWithdrawSGB')
        const events = []
        event.data.data.forEach(element => {
          const item = {
            id: element.transaction_id,
            block_timestamp: element.block_timestamp,
            sgb: this.GLOBAL._toDecimal(element.result.amount, 9)
          }
          events.push(item)
        })
        this.withdrawAll = events
      } catch (e) { console.log({ e }) }
    },
    /* todas los retiros por direccion de cuenta */
    async setWithdrawByUser () {
      //
      const options = {
        only_confirmed: false,
        only_unconfirmed: false,
        only_from: true,
        limit: 20,
        contract_address: this.smartContrac.address
      }
      const list = []
      this.withdrawByUser = []
      try {
        await this.tronGrid.getTransactionsTRC20(
          this.getUserAddress,
          options
        ).then(async resp => {
          for (const element of resp.data.data) {
            const withdraw = {
              id: -1,
              block_timestamp: 0,
              // price: 0,
              // cost: 0,
              sgb: 0
              // symbol: 'USDT'
            }
            withdraw.id = element.transaction_id
            withdraw.block_timestamp = element.block_timestamp
            withdraw.sgb = this.GLOBAL._toDecimal(element.value, 9)
            list.push(withdraw)
          }
          this.withdrawByUser = list
        }).catch(e => Promise.reject(e))
      } catch (e) { console.log({ e }) }
    },
    /* */
    async setAccountDetails () {
      // get Status
      await this.smartContrac.instance.accountDatails(this.getUserAddress).call()
        .then(resp => {
          this.userId = this.tronGrid.tronWeb.toDecimal(resp.id._hex)
          this.recompensas[0].balance = this.GLOBAL._toDecimal(this.tronGrid.tronWeb.toDecimal(resp._trx[0]._hex), 6)
          this.recompensas[0].withdrawn = this.GLOBAL._toDecimal(this.tronGrid.tronWeb.toDecimal(resp._trx[1]._hex), 6)
          this.recompensas[1].balance = this.GLOBAL._toDecimal(this.tronGrid.tronWeb.toDecimal(resp._usdt[0]._hex), 6)
          this.recompensas[1].withdrawn = this.GLOBAL._toDecimal(this.tronGrid.tronWeb.toDecimal(resp._usdt[1]._hex), 6)
        })
        .catch(e => {
          this.userId = 0
          this.recompensas[0].balance = 0
          this.recompensas[0].withdrawn = 0
          this.recompensas[1].balance = 0
          this.recompensas[1].withdrawn = 0
          console.log('error', { e })
        })
    },
    async setAllWithdrawRef () {
      try {
        const event = await this.tronGrid.getEventByContract(this.smartContrac.address, 'event_withdraw')
        const events = []
        event.data.data.forEach(element => {
          const item = {
            id: element.transaction_id,
            block_timestamp: element.block_timestamp,
            sgb: this.GLOBAL._toDecimal(element.result.amount, 6),
            account: element.result.account === '0' ? 'TRX' : 'USDT'
          }
          // console.log(element.result.account)
          events.push(item)
        })
        this.withdrawAllRef = events
      } catch (e) { console.log({ e }) }
    },
    /* */
    async setAllowance () {
      await this.smartContrac.instanceUSDT.allowance(this.getUserAddress, this.smartContrac.address).call()
        .then(resp => {
          let allowance = 0
          if (resp._hex !== undefined) {
            allowance = this.tronGrid.tronWeb.toDecimal(resp._hex)
          } else {
            if (resp.remaining !== undefined) {
              allowance = this.tronGrid.tronWeb.toDecimal(resp.remaining._hex)
            }
          }
          if (allowance !== 0) {
            this.pair('SGBT/USDT')
            this.form.onlyUSDT = true
            this.updateFormUSD = Number(this.GLOBAL._toDecimal(allowance, 6).toString().replace(',', ''))
          } else {
            this.updateFormUSD = 0
            this.form.onlyUSDT = false
            this.pair('SGBT/TRX')
          }
        })
        .catch(e => {
          console.log('error', { e })
        })
    },
    /* */
    filterTransfer (data) {
      const lista = []
      data.forEach(element => {
        try {
          if (element.ret[0].contractRet === 'SUCCESS' &&
            element.raw_data.contract[0].parameter.value.call_value !== undefined
          ) {
            const item = {
              value: element.raw_data.contract[0].parameter.value.call_value,
              data: element.raw_data.contract[0].parameter.value.data,
              id: element.txID
            }
            lista.push(item)
          }
        } catch (e) {
          console.log('e', e)
        }
      })
      return lista
    },
    /* set all buy SGBT with TRX in contract by address */
    async setAllBuySGBTRX () {
      // get trx
      await this.tronGrid.getTransactionsByContractTRX(this.getUserAddress)
        .then(resp => {
          console.log('lista', this.filterTransfer(resp.data.data))
        }).catch(e => console.log({ e }))
    }
  }
}
</script>

<style scoped>
.fondos{
    max-width: 500px;
}
.card {
    background-color: #1E1E1E !important;
    border-radius: 0.5rem !important;
}

.txt-color-primary {
    color: #FFF9BC;
    font-family: "Poppins-Light";
}
.txt-color-secondary {
    color: #FFFFFF;
    font-family: "Poppins-Light";
}

form input{
    color: #FFF9BC !important;
    -webkit-text-fill-color: #FFF9BC;
}
form .input-group-text{
    color: #FFF9BC;
    background: none;
    border: none;
}
form .form-control,
form .form-control.is-valid,
.form-control.is-valid:focus,
form .form-control.is-invalid{
    /*base*/
    background-image:none;
    border: 0px solid #FFFFFF !important;
    outline: 0;
    -webkit-box-shadow: 0 0 0 0 #ffff !important;
    box-shadow: 0 0 0 0 #ffff !important;
}
.box .icon{
    background-color: #323232 !important;
}
.box .icon{
    display: table;
    height: 37px;
    width: 37px;
    margin: auto;
    border-radius: 25px;
}
.box .icon .wraper{
    display: table-cell;
    vertical-align: middle;
    text-align: center;
}

@media screen and (min-width: 576px) {
    .box .icon {
        height: 57px;
        width: 60px;
        border-radius: 30px;
    }
}

.wrapper{
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.wrapper .img{
  width: 100%;
  text-align: center;
  color: #f4c96cff;
}
#container-main {
  position: relativa;
}

.main {
  position: relative;
  display: table;
  width: 100%;
  height: 100%;
}
.main:before {
  position: absolute;
    top: 0%;
    left: 0%;
    content: "";
    width: 100%;
    height: 100%;
    display: inline-block;
    background-image: url(../../../assets/02.jpg);
    z-index: -1;
}
.publicidad {
  background: url(../../../assets/publicidad_02.jpg) no-repeat;
  background-size: cover;
  position: relative;
  display: flex;
  flex-flow: row;
  width: 100%;
  min-height: 520px;
}
.description {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}
.description h1,
.description a {
  color: #f9b707 !important;
}

.description p {
  margin: auto;
  max-width: 350px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

</style>
